import { Component, OnInit } from '@angular/core';

declare function initCustomJS();
@Component({
  selector: 'app-fullpages',
  templateUrl: './fullpages.component.html',
  styles: []
})
export class FullPagesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    initCustomJS();
  }

}
